var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01Icons02CategoriesIcOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "82s6z21rha",
    d: "M0 0h20v12.343H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 9.656)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "md0ghe2p6b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#82s6z21rha"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.652 4.686a.21.21 0 0 0-.208.235l.77 6.38a.21.21 0 0 0 .207.185h11.158c.106 0 .195-.08.207-.184l.77-6.381a.209.209 0 0 0-.208-.235H3.652zM.429 12.344a.43.43 0 0 1 0-.858h2.706a.209.209 0 0 0 .209-.234l-.789-6.54a.837.837 0 0 1 .838-.884l.252.001c.11 0 .2-.084.21-.193.152-1.95.997-2.36 1.678-2.36 1.2 0 1.716-.4 2.202-1.093A.432.432 0 0 1 8.087 0a.42.42 0 0 1 .244.078.423.423 0 0 1 .177.277.424.424 0 0 1-.072.32c-.736 1.05-1.55 1.46-2.903 1.46-.45 0-.725.492-.817 1.465a.21.21 0 0 0 .209.23h10.15a.21.21 0 0 0 .208-.23c-.114-1.212-.507-1.466-.816-1.466-1.353 0-2.168-.409-2.904-1.459a.426.426 0 0 1-.07-.32.425.425 0 0 1 .175-.276.425.425 0 0 1 .597.104c.486.692 1.001 1.094 2.202 1.094.681 0 1.526.409 1.679 2.359.008.109.099.193.208.193h.252a.838.838 0 0 1 .838.886l-.788 6.537a.208.208 0 0 0 .208.234h2.707a.43.43 0 0 1 0 .858H.43z",
    fill: "#000",
    mask: "url(#md0ghe2p6b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.895a.849.849 0 0 0 0 1.695.849.849 0 0 0 0-1.695m0 2.552c-.94 0-1.705-.764-1.705-1.704s.765-1.705 1.705-1.705c.94 0 1.705.764 1.705 1.705 0 .94-.765 1.704-1.705 1.704M12 2.857c-1.127 0-1.698.776-1.698 2.307 0 1.866 1.014 3.217 1.698 3.217.684 0 1.698-1.351 1.698-3.217 0-1.53-.571-2.307-1.698-2.307m0 6.381c-1.361 0-2.556-1.904-2.556-4.074C9.444 3.154 10.376 2 12 2c1.6 0 2.555 1.183 2.555 3.164 0 2.17-1.194 4.074-2.555 4.074",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Icons02CategoriesIcOverview);
export default __webpack_public_path__ + "static/media/01-icons-02-categories-ic-overview.89e47db6b8b7f8288e9766e55f4927f1.svg";
export { ForwardRef as ReactComponent };